import GestaoPortfolios from "../../components/GestaoPortfolios";
import BannerOtimizeNegocio from "../../components/banner-otimize-negocio";
import BannerProjects from "../../components/bannerProjects";
import Diferenciais from "../../components/diferenciais";
import Rodape from "../../components/rodape";

export default function Pmo() {
    return (
        <>
            <BannerProjects
                backgroundImage="../assets/cover-pmo.png"
                bgMobile="../assets/cover-pmo-mobile.png"
                title="/PMO AS"
                titleBold="A SERVICE"
                iconSrc="../assets/icone-projectiva-behub.png"
                iconAlt="Projectiva BeHub"
                iconText="be."
                iconTextBold="hub"
                descriptionBold="Todo grande projeto precisa de uma base sólida para alcançar resultados extraordinários."
                description="Com o PMO as a Service, você conta com uma estrutura dedicada e suporte especializado para garantir uma gestão de projetos mais ágil, eficiente e estratégica. É a escolha ideal para empresas que querem ir além, com controle, clareza e foco no que realmente importa: entregar valor."
                footerText="VERTICAL PROJECTS | Business Agility"
                buttonText="Quero me conectar"
                buttonColor="from-[#4B3BDB] to-[#A002CB]"
                brand="behub"
            />
            <GestaoPortfolios
                items={[
                    {
                        title: "GESTÃO DE PORTFÓLIO DE PROJETOS",
                        content: (
                            <>
                                <strong className="font-inter-bold">
                                    Acompanhar e gerenciar
                                </strong>{" "}
                                os projetos em andamento na organização,
                                garantindo que sejam corretamente priorizados de
                                acordo com os <br />
                                <strong className="font-inter-bold">
                                    objetivos estratégicos
                                </strong>{" "}
                                da empresa.
                            </>
                        ),
                    },
                    {
                        title: "GESTÃO DE MUDANÇAS",
                        content: (
                            <>
                                <strong className="font-inter-bold">Conduzir</strong>{" "}
                                a implementação de novos métodos e a{" "}
                                <strong className="font-inter-bold">
                                    adoção de mudanças culturais e operacionais
                                </strong>
                                , assegurando uma transição eficiente e o
                                engajamento das equipes ao longo do processo.
                            </>
                        ),
                    },
                    {
                        title: "GESTÃO DE PESSOAS",
                        content: (
                            <>
                                <strong className="font-inter-bold">
                                    Desenvolver
                                </strong>{" "}
                                e acompanhar o time, elaborando planos de
                                desenvolvimento individual (PDI), oferecendo
                                feedbacks contínuos e conduzindo a{" "}
                                <strong className="font-inter-bold">
                                    gestão de conflitos
                                </strong>{" "}
                                de forma construtiva.
                            </>
                        ),
                    },
                    {
                        title: "PLANEJAMENTO E DEFINIÇÃO DE ESCOPO",
                        content: (
                            <>
                                Contribuir para a{" "}
                                <strong className="font-inter-bold">
                                    definição de escopo, cronogramas e alocação
                                    de recursos
                                </strong>
                                , atuando para garantir que as expectativas dos
                                stakeholders sejam atendidas e os prazos,
                                rigorosamente cumpridos.
                            </>
                        ),
                    },
                    {
                        title: "MONITORAMENTO E CONTROLE",
                        content: (
                            <>
                                Acompanhar o progresso dos projetos, elaborar
                                relatórios de status,
                                <strong className="font-inter-bold">
                                    {" "}
                                    identificar e mitigar riscos
                                </strong>
                                , além de ajustar o planejamento sempre que
                                necessário.
                            </>
                        ),
                    },
                    {
                        title: "METODOLOGIAS E MELHORES PRÁTICAS",
                        content: (
                            <>
                                Definir, implementar e{" "}
                                <strong className="font-inter-bold">
                                    padronizar metodologias de gestão de
                                    projetos
                                </strong>{" "}
                                — sejam elas ágeis, tradicionais ou híbridas —
                                garantindo que as equipes sigam as{" "}
                                <strong className="font-inter-bold">
                                    melhores práticas
                                </strong>{" "}
                                para uma entrega eficiente e de qualidade.
                            </>
                        ),
                    },
                ]}
            />
            <BannerOtimizeNegocio
                headingBold="Aceleramos a sua jornada de transformação ágil, "
                headingText="impulsionando a evolução contínua."
                buttonText="Otimize seu negócio!"
                buttonUrl="/"
            />
            <Diferenciais
                servicosData={[
                    {
                        icon: "../assets/icone-melhoria.png",
                        iconHover: "../assets/icone-melhoria.png",
                        title: "Gestão de Portfólio de Projetos",
                        text: (
                            <>
                                <strong>Acompanhar e gerenciar</strong> os
                                projetos em andamento na organização, garantindo
                                que sejam corretamente priorizados de acordo com
                                os <strong>objetivos estratégicos</strong> da
                                empresa.
                            </>
                        ),
                        glowColor: "#A800E4",
                        url: "",
                    },
                    {
                        icon: "../assets/icone-suporte.png",
                        iconHover: "../assets/icone-suporte.png",
                        title: "Gestão de Qualidade",
                        text: (
                            <>
                                Assegurar que os{" "}
                                <strong>processos e entregáveis</strong> dos
                                projetos atendam aos padrões de qualidade
                                elevados e que agreguem resultados tangíveis.
                            </>
                        ),
                        glowColor: "#A800E4",
                        url: "",
                    },
                    {
                        icon: "../assets/icone-risco.png",
                        iconHover: "../assets/icone-risco.png",
                        title: "Gestão de Riscos",
                        text: (
                            <>
                                Identificar, avaliar e gerenciar os riscos dos
                                projetos, propondo soluções para mitigação de
                                impactos negativos no andamento dos processos.
                            </>
                        ),
                        glowColor: "#A800E4",
                        url: "",
                    },
                    {
                        icon: "../assets/gestao-icone.png",
                        iconHover: "../assets/gestao-icone.png",
                        title: "Comunicação com Stakeholders",
                        text: (
                            <>
                                <strong>Facilitar a comunicação</strong> entre
                                os participantes do projeto (stakeholders),
                                garantindo que todos os envolvidos estejam
                                alinhados quanto aos{" "}
                                <strong>objetivos, prazos e entregas</strong>.
                            </>
                        ),
                        glowColor: "#A800E4",
                        url: "",
                    },
                    {
                        icon: "../assets/gestao-icone.png",
                        iconHover: "../assets/gestao-icone.png",
                        title: "Gestão de Recursos",
                        text: (
                            <>
                                <strong>
                                    Coordenar a alocação de recursos humanos e
                                    financeiros
                                </strong>{" "}
                                nos projetos, garantindo sua disponibilidade de
                                forma eficiente e alinhada às necessidades de
                                cada etapa.
                            </>
                        ),
                        glowColor: "#A800E4",
                        url: "",
                    },
                    {
                        icon: "../assets/icone-suporte.png",
                        iconHover: "../assets/icone-suporte.png",
                        title: "Suporte e Consultoria",
                        text: (
                            <>
                                Disponibilizar suporte às equipes de projeto,
                                por meio de{" "}
                                <strong>
                                    treinamentos, consultoria técnica
                                </strong>{" "}
                                e auxílio no uso de ferramentas de
                                gerenciamento.
                            </>
                        ),
                        glowColor: "#A800E4",
                        url: "",
                    },
                ]}
                title="Diferenciais"
            />
            <Rodape />
        </>
    );
}
